export default "__VITE_ASSET__BOWZM0j1__"